const normalizeBundledJsonImport = (imported) => {
	if (imported == null) return {}
	if (typeof imported === 'object' && !Array.isArray(imported)) return imported
	if (typeof imported === 'string') {
		try {
			return JSON.parse(imported)
		} catch {
			return {}
		}
	}
	return {}
}

const asPayloadWithArrayField = (imported, field) => {
	const parsed = normalizeBundledJsonImport(imported)
	if (Array.isArray(parsed)) {
		return { [field]: parsed }
	}
	const list = Array.isArray(parsed[field]) ? parsed[field] : []
	return { ...parsed, [field]: list }
}

export const asBundledOfflinePayload = (imported) =>
	asPayloadWithArrayField(imported, 'content')

export const asBundledSeoListPayload = (imported) =>
	asPayloadWithArrayField(imported, 'results')